<template>
    <client-page>
        <section class="section">
            <v-container>
                <div class="section-title-wrap" >
                    <h2 class="client-title--xxxl">위드캔 스토리</h2>
                </div>

                <template v-if="!$route.params._board && $route.query.mode !== 'input'">
                    <v-tabs v-model="tab" grow hide-slider :show-arrows="false" class="board-tabs">
                        <v-tab exact to="/board/story">전체</v-tab>
                        <v-tab exact to="/board/story/newsletter">재단 소식</v-tab>
                        <v-tab exact to="/board/story/supporter">후원자 소식</v-tab>
                        <v-tab exact to="/board/story/news">사업기관 소식</v-tab>
                    </v-tabs>

                    <board-list code="news" :limit="6" />

                    <!-- <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <board-list :code="[`newsletter`, `supporter`, `news`]" :limit="6" />
                        </v-tab-item>
                        <v-tab-item>
                            <board-list code="newsletter" :limit="6" />
                        </v-tab-item>
                        <v-tab-item>
                            <board-list code="supporter" :limit="6" />
                        </v-tab-item>
                        <v-tab-item>
                            <board-list code="news" :limit="6" />
                        </v-tab-item>
                    </v-tabs-items> -->
                </template>
                <board-write v-else-if="$route.query.mode === 'input'" />
                <board-view v-else />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualBoard from "@/components/client/sub/sub-visual-borad.vue";
// import TabFair from "@/components/client/sub/tab-fair.vue";
import BoardView from "@/components/client/support/board-view.vue";
import BoardList from "@/components/client/support/board-list.vue";
import BoardWrite from "@/components/client/support/board-write.vue";

import NewsList from "@/components/client/support/news-list.vue";

export default {
    components: {
        ClientPage,
        SubVisualBoard,
        // TabFair,
        BoardView,
        BoardList,
        BoardWrite,
        NewsList,
    },
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {},
    },
    watch: {
        code() {},
    },
};
</script>

<style lang="scss" scoped>
.board-tabs {
    margin-bottom: 40px;
    ::v-deep(.v-slide-group__prev) {
        display: none;
    }
    .v-tab {
        background-color: #f5f5f5;
        &:first-of-type {
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
        }
        &:last-of-type {
            border-top-right-radius: 999px;
            border-bottom-right-radius: 999px;
        }
        &--active {
            background-color: var(--v-primary-base);
            color: #fff;
        }
    }
}
.library-report {
    padding: 40px 0;
    margin-bottom: 40px;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100vw;
        max-width: 1920px;
        height: 100%;
        background: rgb(100, 148, 67) url(/images/news/library.jpg) no-repeat center / cover;
    }
    &__inner {
        position: inherit;
        z-index: 1;
    }
}
@media (min-width: 768px) {
    .board-tabs {
        margin-bottom: 60px;
        ::v-deep(.v-tabs-bar),
        .v-tab {
            height: 60px;
        }
    }
    .library-report {
        padding: 86px 0;
        margin-bottom: 80px;
    }
}
</style>